import React, { type CSSProperties } from 'react';
import cx from 'classnames';

import './DefinitionList.scss';

/** Wrapper for HTML definition list: `<dl />` */

interface DefinitionListProps {
  alignLeft?: boolean;
  nameWidth?: number; // in %
  tableLayout?: boolean;
  variant?: 'default' | 'preview';
  terms: {
    key?: string | number;
    name: string;
    definition: string | React.ReactNode;
  }[];
}

const DefinitionList: React.FC<DefinitionListProps> = ({
  alignLeft,
  nameWidth,
  tableLayout,
  variant = 'default',
  terms = [],
}) => (
  <dl
    className={cx({
      'definition-table': tableLayout,
      'align-left': alignLeft,
      [`definition-table--${variant}`]: tableLayout && variant !== 'default',
    })}
    style={
      {
        '--name-width': nameWidth ? `${nameWidth}%` : '40%',
      } as CSSProperties
    }
  >
    {terms
      .filter(x => x)
      .map((term, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={term.key || i}>
          <dt>{term.name}: </dt>
          <dd>{term.definition}</dd>
        </div>
      ))}
  </dl>
);

export default DefinitionList;
